import i18n from 'i18n';
import type { FilterResponse, FilterV2 } from 'types/global.types';
import type { TagItemType } from 'types/repository.types';

export const adaptFilters = (
  data: FilterResponse[],
  tags: TagItemType[],
): FilterV2[] => {
  return data.map((filterData) => {
    const key = filterData.key;

    return {
      ...filterData,
      isV2: true,
      key,
      label: i18n.t(`documents_repository.filters.${filterData.key}`),
      options: (() => {
        if (filterData.key === 'dateRange') {
          return [];
        }
        if (filterData.key === 'tags') {
          return filterData?.values.map((_tag) => ({
            label: _tag?.name,
            value: _tag._id,
          }));
        }
        return filterData?.values?.map((value: string) => ({
          label: i18n.t(`documents_repository.choices.${String(value)}`),
          value,
        }));
      })(),
    };
  });
};
